import { faHourglass } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components';

const NodeContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: #efe9e3;
  border: 1px solid #bfbab5;
  width: 220px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`;

const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const NodeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #a7a39a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 8px;
`;

const NodeLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #777471;
  flex: 1;
`;

const NodeType = styled.div`
  font-size: 10px;
  background: rgba(0, 0, 0, 0.04);
  color: #555;
  padding: 2px 6px;
  border-radius: 4px;
`;

const NodeDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
`;

const ManualTaskNode = ({ data }) => {
  const {
    name = 'Manual Task',
    description = 'Manual review and decision task',
  } = data || {};

  return (
    <NodeContainer>
      <Handle type="target" position={Position.Top} />

      <NodeHeader>
        <NodeIcon>
          <FontAwesomeIcon icon={faHourglass} />
        </NodeIcon>
        <NodeLabel>{name}</NodeLabel>
        <NodeType>Manual Task</NodeType>
      </NodeHeader>

      <NodeDescription>{description}</NodeDescription>

      <Handle type="source" position={Position.Bottom} />
    </NodeContainer>
  );
};

export default memo(ManualTaskNode);
